import React, { Component } from "react";
class RowElement extends Component {
    state = {
        isDraggedOver: false
    };
    onDragOver = () => {
        this.props.addGhostElementOnDragOver("Element", {
            elementId: this.props.elementId
        });
    };
    onDragLeave = () => {
        this.props.removeGhostElementOnDragLeave("Element", {
            elementId: this.props.elementId
        });
    };
    render() {
        let { width, minHeight } = this.props.elementStyle;
        return (
            <div
                onDragOver={() =>
                    !this.state.isDraggedOver && this.onDragOver()
                }
                onDragLeave={() =>
                    this.state.isDraggedOver && this.onDragLeave()
                }
                style={{
                    width: `${width}%`,
                    minHeight: `${minHeight}%`
                }}
            ></div>
        );
    }
}

export default RowElement;
